import React, { Component } from "react";
import { readableResponseMessage } from "ux-helpers";
import PropTypes from "proptypes";
import { Auth, API } from "aws-amplify";
import { Link } from "react-router-dom";

export default class DeleteItemModal extends Component {
  state = {};

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ loadingBtn: true });
    Auth.currentSession().then(user => {
      const options = {
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken,
          "Content-Type": "application/json"
        },
        body: { id: this.props.tripId }
      };
      API.del("give-api", `/user/trips/${this.props.tripId}`, options)
        .then(response => {
          if (this.props.deleteTripHandler) {
            this.props.deleteTripHandler(this.props.tripId);
          } else {
            this.props.handleRouting();
          }
        })
        .catch(error => {
          this.setState({
            loadingBtn: false,
            message: readableResponseMessage(error)
          });
        });
    });
  };

  changeTripHandler = () => {
    this.props.setParentState("replaceOpportunityId", this.props.tripId);
    this.props.history.push("/trip-selection");
  };

  render() {
    return (
      <div>
        <div className="row">
          <button className="square-icon right" onClick={this.props.closeModal}>
            X
          </button>
        </div>

        <h3 className="h1-style muted">
          Are you sure you want to add a trip?
        </h3>
        <p>If you'd like to replace your current trip with a new trip, or change your trip to a package, select "Change Trip" below.  If you'd like to travel to an additional destination, select "Add an Additional Trip" below.</p>
        {this.state.message ? (
          <p
            className={`center ${
              this.state.message === "Successfully Deleted"
                ? "success"
                : "error"
            }`}
          >
            {this.state.message}
          </p>
        ) : (
          ""
        )}
        <div className="center">
            {/* 
            {!this.props.hasPaidAnyAmount ? (
            <button
              onClick={e => this.handleSubmit(e)}
              className={`${this.state.loadingBtn ? "btn-text-hide" : ""}`}
              type="button"
              disabled={this.state.loadingBtn}
            >
              Delete
              <span className={`${this.state.loadingBtn ? "loader" : ""}`} />
            </button> 
            ) : ""}
            */}
            <button
              onClick={() => this.changeTripHandler()}
              className="inline"
              type="button"
            >
              Change Trip
            </button>
            <Link to="/trip-selection"
              className="button inline"
              type="button"
            >
              Add an Additional Trip
            </Link>
      </div>
      </div>
    );
  }
}

DeleteItemModal.propTypes = {
  deleteTripHandler: PropTypes.func.isRequired,
  hasPaidAnyAmount: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleRouting: PropTypes.func.isRequired,
  tripId: PropTypes.string.isRequired,
  setParentState: PropTypes.func.isRequired
};
